module.exports = __webpack_public_path__ + "static/media/mla.9e618788.png";